export const MON_COMPTE = {
    SET_MODAL: 'MON_COMPTE_SET_MODAL',
    RESET: 'MON_COMPTE_RESET',
};
